/**
 *
 * Edit Snowflake
 *
 */

import React, { memo } from 'react';

import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { selectCloudAccounts } from 'containers/Setup/CloudAccounts/selectors';

import { Snowflake } from '.';

export const EditSnowflake = memo(() => {
  const { accountDetails } = useSelector(selectCloudAccounts);
  const navigate = useNavigate();

  return (
    <Snowflake
      action="Update"
      accountDetails={accountDetails.data}
      accountDetailsIsLoading={accountDetails?.isLoading}
      onClickCancel={() => navigate('/setup/accounts')}
    />
  );
});
